/*
 * Copyright (c) Orion Developments Ltd and the Orion Health group of companies (2001 - 2021).
 *
 * This document is subject to copyright. Except as permitted by copyright law
 * applicable to you, no part of this publication may be reproduced or
 * transmitted in any form or by any means, electronic or mechanical, including
 * photocopying, recording, downloading, or any information storage and
 * retrieval system, without permission in writing from Orion Developments
 * Limited. Infringers of copyright render themselves liable for prosecution.
 */

import { Nodes, Role, Node } from './Interfaces'

/** Recursive function to find a role from nested structure */
function getChildrenMatchingRole(node: Node, selectedNode: string): Role | undefined {
    for (let child of node.Children) {
        const result = getChildrenMatchingRole(child, selectedNode)
        if (result !== undefined) {
            return result
        }
    }
    return node.Roles.find(role => role.Name === selectedNode)
}

export default function findRole(rolesData: Nodes, role: string): Role | undefined {
    for (let eachNode of rolesData.Node) {
        const matchingNodeRole = getChildrenMatchingRole(eachNode, role)
        if (matchingNodeRole !== undefined) {
            return matchingNodeRole;
        }
    }
    return undefined
}